import React, { forwardRef } from "react";
import { Size } from "@type/sizing";
import { HelperText } from "@components/helperText";
import { InputLabel } from "@components/inputLabel";
import { CalenderIcon } from "@assets/icons";
import { antdStatusMap } from "@constants/input";
import { StyledRangePicker } from "./rangePicker.styles";
import { RangePickerProps, RangePickerRef } from "./rangePicker.types";

const helperTextMap = {
    error: "danger",
};

export const RangePicker = forwardRef(
    (
        {
            label,
            required,
            status = "default",
            helperText,
            disabled,
            size = "medium",
            wrapperClassName,
            ...rest
        }: RangePickerProps,
        ref: RangePickerRef
    ) => {
        const isAllDisabled =
            disabled instanceof Array ? disabled.every(Boolean) : disabled;

        return (
            <div className={wrapperClassName}>
                {label && <InputLabel required={required}>{label}</InputLabel>}
                <StyledRangePicker
                    ref={ref}
                    suffixIcon={<CalenderIcon width={16} height={16} />}
                    status={antdStatusMap[status]}
                    disabled={disabled}
                    size={Size[size]}
                    {...rest}
                ></StyledRangePicker>
                {helperText && (
                    <HelperText
                        disabled={isAllDisabled}
                        type={helperTextMap[status] || status}
                    >
                        {helperText}
                    </HelperText>
                )}
            </div>
        );
    }
);

RangePicker.displayName = "RangePicker";
